export default "__VITE_PUBLIC_ASSET__2590c859__"